import Button from 'components/button';
import * as Sentry from '@sentry/react';
import { memo, useEffect, useRef, useState } from 'react';

export const ButtonFeedBackMemo = memo(function () {
  const refFeedback = useRef<HTMLDivElement>(null);
  const [isSetRef, setIsSetRef] = useState(false);

  useEffect(() => {
    if (refFeedback.current !== null && !isSetRef) {
      setIsSetRef(true);
    }
  }, [refFeedback.current]);

  useEffect(() => {
    if (isSetRef && refFeedback.current) {
      Sentry.getFeedback()?.attachTo(refFeedback.current);
    }
  }, [isSetRef]);

  const handleFeedBack = () => {
    Sentry.getFeedback();
  };

  return (
    <div ref={refFeedback}>
      <Button label='Сообщить об ошибке' variant='dark' onClick={handleFeedBack} />
    </div>
  );
});
